import { ReactNode } from "react";
import cn from "classnames";
import { SDSHeadingProps } from "@politiet/sheriff-web-components";

export type HeadingLevel = SDSHeadingProps["level"];
export type HeadingSize = SDSHeadingProps["size"];

type HeadingProps = SDSHeadingProps & {
  slot?: string;
  children: ReactNode;
  id?: string;
  className?: string;
};

const levelSize: Record<NonNullable<HeadingLevel>, HeadingSize> = {
  h1: "xl",
  h2: "lg",
  h3: "md",
  h4: "sm",
  h5: "xs",
  h6: "xs",
};

//TODO: sett level automatisk basert på context: https://react.dev/learn/passing-data-deeply-with-context
export default function Heading({
  level = "h1",
  children,
  size,
  className,
  ...props
}: HeadingProps) {
  const Tag = level;
  const levelClass = `sds-heading-${levelSize[level]}`;
  const asClass = size ? `sds-heading-${size}` : undefined;

  return (
    <Tag {...props} className={cn(asClass ? asClass : levelClass, className)}>
      {children}
    </Tag>
  );
}
